import {DICT_KEY, getModel} from "../../../utils/constants";

const MODEL_KEY = DICT_KEY.PURCHASE_INVOICE;
const storageModel = getModel(MODEL_KEY);

const purchaseInvoiceModel = {
    state: storageModel ? storageModel :{},
    reducers: {},
    effects: () => ({})
}

export default purchaseInvoiceModel;